<template>
  <div type="text" class="header-input layout align-center" autoresize>
    <div
      :contenteditable="!disabled"
      class="input-text header-input"
      @input="e => (backupText = e.target.innerText)"
    >
      {{ text }}
    </div>

    <v-spacer />
    <div contenteditable="false">
      <v-slide-x-reverse-transition class="justify-self-end">
        <v-btn
          v-show="showSaveButton"
          :loading="isLoading"
          x-small
          depressed
          color="primary"
          class="justify-self-end"
          @click.stop="
            isLoading = true;
            action(backupText);
            showSaveButton = false;
            isLoading = false;
            setInitialValue(backupText);
          "
        >
          Save
        </v-btn>
      </v-slide-x-reverse-transition>
    </div>
  </div>
</template>

<script>
let initialValue = null;
export default {
  name: 'CleanInput',
  props: {
    action: Function,
    initialValue: String,
    disabled: Boolean
  },
  data() {
    return {
      showSaveButton: false,
      isLoading: false,
      text: this.initialValue,
      backupText: this.initialValue
    };
  },
  watch: {
    initialValue(o) {
      if (o) {
        this.text = o;
        initialValue = o;
      }
    },
    backupText(o, n) {
      if (o !== initialValue) {
        this.showSaveButton = true;
      } else {
        this.showSaveButton = false;
      }
    }
  },
  mounted() {
    if (this.initialValue) {
      initialValue = this.initialValue;
    }
  },
  methods: {
    setInitialValue(value) {
      initialValue = value;
    }
  }
};
</script>

<style scoped>
.header-input {
  outline: none;
}
.header-input:focus {
  border-bottom: 1px solid var(--lightish-blue);
}
</style>
